import { withStyles } from '@material-ui/core';

import TimiryazevParkingPage from './component';
import styles from './styles';

export default withStyles(styles)(TimiryazevParkingPage);
